import * as THREE from 'three';

export function createCamera() {
  const camera = new THREE.PerspectiveCamera(
    75, // FOV for immersive feel
    window.innerWidth / window.innerHeight, // Aspect ratio
    0.1, // Near clipping plane
    100 // Far clipping plane
  );

  // Set initial camera position (will be overridden by controls)
  camera.position.set(0, 1.6, 0); // 1.6m is average eye height

  return camera;
}
